import ReCAPTCHA from 'react-google-recaptcha';
import React, { createRef } from 'react';
import Widget from './Widget';

const TEST_RECAPTCHA_CODE = '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI';
const extractParams = (search: string) => search.slice(1).split('&').reduce((acc: any, param) => {
    const [key, value] = param.split('=');
    acc[key] = value;
    return acc;
}, {});

function App() {
    const recaptchaRef = createRef<ReCAPTCHA>();

    const { formId, host, recaptchaClient } = extractParams(window.location.search);

    return (
        <>
            <Widget
                recaptcha={recaptchaRef}
                formId={formId}
                host={host}
            />
            <ReCAPTCHA
                ref={recaptchaRef}
                size="invisible"
                sitekey={recaptchaClient || TEST_RECAPTCHA_CODE}
            />
        </>
    );
}

export default App;
